import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";

import { AbstractComponent } from "./abstract.component";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";

@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class AbstractUserComponent extends AbstractComponent {
    user: User = new User();
    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        protected authService: AuthService
    ) {
        super(router, route, dialog, analyticsService, generalService);
        this.initPromises.push(this.reloadUser());
    }

    reloadUser(): Promise<User> {
        return this.generalService.getDetails()
            .then(u => {
                if (u == null) {
                    this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
                } else {
                    this.user = Object.assign(new User(), u);
                }                
                return u;
            });
    }
}